import React from 'react';
import { Cloud, Globe, Network, Users } from 'lucide-react';

const TechnologyEcosystem = () => {
  const ecosystems = [
    { icon: Cloud, name: 'Cloud distributors and marketplaces' },
    { icon: Globe, name: 'SaaS platforms with partner networks' },
    { icon: Network, name: 'Vendor ecosystems and alliances' },
    { icon: Users, name: 'Channel and partner enablement teams' }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Built for Complex Ecosystems
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Traain supports:
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <div className="grid md:grid-cols-2 gap-6">
            {ecosystems.map((ecosystem, index) => {
              const Icon = ecosystem.icon;
              return (
                <div
                  key={index}
                  className="flex items-center gap-4 p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
                >
                  <div className="w-12 h-12 bg-cyan-500/10 border border-cyan-500/30 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Icon className="w-6 h-6 text-cyan-400" />
                  </div>
                  <p className="text-lg text-gray-300">{ecosystem.name}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="text-center">
          <p className="text-lg text-gray-400 italic">
            All powered by Navigator AI, quietly working in the background so your people can lead with confidence.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TechnologyEcosystem;
